<template>
  <div class="spinnerContainer">
    <looping-rhombuses-spinner
      :animation-duration="2500"
      :color="mainGreen"
      :rhombus-size="15"
    />
  </div>
</template>

<script>
import { MAIN_GREEN } from "@/setup.const";
import { LoopingRhombusesSpinner } from "epic-spinners";

export default {
  data: () => ({ mainGreen: MAIN_GREEN }),
  props: ["size"],
  components: {
    LoopingRhombusesSpinner,
  },
};
</script>

<style lang="scss" scoped>
.spinnerContainer {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  //align-items: center; //display: flex; //height: 100%; //justify-content: center; //width: 100%;
}

svg circle {
  stroke: var(--main-green) !important;
}
</style>
